"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _moment = _interopRequireDefault(require("moment"));
var _Flex = _interopRequireDefault(require("../Flex"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Day = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 2px;\n  font-size: 44px;\n  font-weight: 700;\n"])));
var Month = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 700;\n"])));
var Year = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 700;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.primaryFaded;
});
var PrettyDate = function PrettyDate(_ref2) {
  var date = _ref2.date;
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(Day, null, (0, _moment["default"])(date).format('D')), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(Month, null, (0, _moment["default"])(date).format('MMMM')), /*#__PURE__*/_react["default"].createElement(Year, null, (0, _moment["default"])(date).format('YYYY'))));
};
PrettyDate.propTypes = {
  date: (0, _propTypes.instanceOf)(Date)
};
var _default = exports["default"] = PrettyDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/abihome-components/build/components/PrettyDate/index.js
// module id = 350
// module chunks = 17